import { render, staticRenderFns } from "./section5.vue?vue&type=template&id=6ef4983c&scoped=true&"
import script from "./section5.vue?vue&type=script&lang=js&"
export * from "./section5.vue?vue&type=script&lang=js&"
import style1 from "./section5.vue?vue&type=style&index=1&id=6ef4983c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4983c",
  null
  
)

export default component.exports